import { gdprCookies } from '@bedrock-rdk/config';
import { t } from '../../i18n';
import { areCookiesEmpty } from '../../../logic/gdprNotice/gdprNotice.utils';

// NOTE: the second part of conditions works in case when a user opens the app for the first time
// and the cookies never being saved
export const isUpdated = (savedCookies, selectedCookies) =>
  gdprCookies.some(category => savedCookies[category] !== selectedCookies[category]) &&
  !(areCookiesEmpty(savedCookies) && gdprCookies.every(category => selectedCookies[category] === false));

export const getBackButtonLabel = (savedCookies, selectedCookies) =>
  isUpdated(savedCookies, selectedCookies) ? t('global.backSave') : t('global.back');
